import { useWeb3React } from '@web3-react/core';
import {
    CopyIcon,
    DisconnectIcon,
    SettingsIcon,
    TxLinkIcon,
    WalletIcon,
} from '../../../assets/icons';
import { formatAccount } from '../../../helpers';
import { ethers } from 'ethers';
import Button from '../../../components/Button';
import CopyPopUp from '../../../components/CopyPopUp';
import useConnectionState from '../../../context/connection/useConnectionState';
import { CHAIN_INFO, EnabledChains } from '../../../config/constants';
import { Dispatch, SetStateAction } from 'react';
import clsx from 'clsx';

type WalletDropdownHeaderProps = {
    renderSlippage: boolean;
    setRenderSlippage: Dispatch<SetStateAction<boolean>>;
};

const WalletDropdownHeader: React.FC<WalletDropdownHeaderProps> = ({
    renderSlippage,
    setRenderSlippage,
}) => {
    const { account, chainId } = useWeb3React();

    const { handleDisconnect } = useConnectionState();

    return (
        <div className='wallet-dropdown-header'>
            <div className='account'>
                <WalletIcon />
                {formatAccount(account || ethers.constants.AddressZero)}
            </div>
            <div className='actions-container'>
                <CopyPopUp
                    copyText={account || ''}
                    trigger={
                        <Button variant='tertiary'>
                            <CopyIcon />
                        </Button>
                    }
                >
                    Copied!
                </CopyPopUp>
                <Button
                    variant='tertiary'
                    className={clsx('settings-button', { active: renderSlippage })}
                    onClick={() => setRenderSlippage(true)}
                    disabled={renderSlippage}
                >
                    <SettingsIcon />
                </Button>
                <Button
                    variant='tertiary'
                    className='tx-link-button'
                    externalLink={`${
                        CHAIN_INFO[chainId as EnabledChains[number]]?.blockExplorer
                    }/address/${account}`}
                >
                    <TxLinkIcon />
                </Button>
                <Button
                    variant='tertiary'
                    className='disconnect-button'
                    onClick={handleDisconnect}
                >
                    <DisconnectIcon />
                </Button>
            </div>
        </div>
    );
};

export default WalletDropdownHeader;
